import type { ReactNode } from 'react'

import AtomSelect from '@/components/Atoms/AtomSelect/AtomSelect'
import HoverElement from '@/components/Atoms/HoverElement/HoverElement'

const TRUE_VALUE = 'true'
const FALSE_VALUE = 'false'

type BooleanSelectProps = {
  title: ReactNode
  value: boolean
  trueLabel: string
  falseLabel: string
  isOrganisationSelected: boolean
  error?: string
  onChange: (value: boolean) => void
}

function BooleanSelect({
  title,
  value,
  trueLabel,
  falseLabel,
  isOrganisationSelected,
  error = '',
  onChange,
}: BooleanSelectProps) {
  return (
    <HoverElement>
      <AtomSelect
        layout="stacked"
        outlined
        size="large"
        valueMode="value"
        openByHover={false}
        isOrganisationSelected={isOrganisationSelected}
        title={title}
        options={[
          { value: TRUE_VALUE, label: trueLabel },
          { value: FALSE_VALUE, label: falseLabel },
        ]}
        value={value ? TRUE_VALUE : FALSE_VALUE}
        allowClear={false}
        error={error}
        handleChange={(nextValue) => onChange(nextValue === TRUE_VALUE)}
      />
    </HoverElement>
  )
}

export default BooleanSelect
